<template>
  <div>
    <a-form-item
      v-if="!hasMultiple"
    >
      <div style="display: flex">
        <a-input v-model.lazy="selectedPath">
          <a-icon
            slot="prefix"
            type="folder"
          />
        </a-input>
        <a-button
          v-if="options.hideSearch !== true"
          type="link"
          size="small"
          class="optionBtnSearch"
          tabindex="-1"
          @click="openDirectoryModal"
        >
          <a-icon type="search"/>
        </a-button>
      </div>
    </a-form-item>
    <a-modal
      :visible="modalOpened"
      :cancel-text="$t('_.cancel')"
      :ok-text="$t('_.ok')"
      @cancel="modalOpened = false"
      @ok="closeDirectoryModal"
    >
      <file-tree
        v-model="modalValue"
        :multiple="hasMultiple"
        :module="references"
        :selected-paths="[modalSelectedPath]"
        style="margin-bottom: 14px"
      />
    </a-modal>
  </div>
</template>

<script>
import Field from '@/components/fields/Field'
import FileTree from '@/components/FileTree'
import FileEntity from '@/api/files/fileEntity'

export default {
  name: 'FieldDirectory',
  components: { FileTree },
  extends: Field,
  data: function () {
    return {
      modalOpened: false,
      selectedPath: '',
      modalSelectedPath: '',
      modalValue: null,
    }
  },
  watch: {
    out_value (value) {
      if (!value || this.hasMultiple || this.selectedPath === value.fullPath) return
      const file = value instanceof FileEntity ? value : new FileEntity(value)
      this.modalValue = file
      this.selectedPath = file.fullPath
    },
    modalValue (file) {
      if (!file) return
      this.modalSelectedPath = file.fullPath
    },
  },
  created () {
    // If there is a value to prefill, properly handle it
    if (!this.hasMultiple && this.out_value) {
      this.out_value = new FileEntity(this.out_value)
      this.selectedPath = this.out_value.fullPath
      this.modalValue = this.out_value
    }
  },
  methods: {
    openDirectoryModal () {
      this.modalOpened = true
    },
    closeDirectoryModal () {
      this.out_value = this.modalValue
      this.modalOpened = false
    },
  },
}
</script>

<style scoped>
.optionBtnSearch {
  width: auto;
  display: flex;
  align-items: center;
  border-radius: 0;
  border: 1px solid #d9d9d9;
  padding: 0 11px;
  height: auto;
  margin-left: -1px;
}

.optionBtnSearch:hover {
  background: #eee;
  border: 1px solid #ccc;
}
</style>
